
// moved this to sections / main-collection-product-grid.liquid
function removeRingSizeInTitles() {
  const divs = document.querySelectorAll(".product-item__product-title a");
  // Loop through the selected divs
  divs.forEach(div => {
    // Do something with each div
    var productTitle = div.textContent;
    var newproductTitle = productTitle.replace(" / 6", "");
    div.textContent = newproductTitle;
    //console.log(newproductTitle); 
  });
}
//wait... then run
//const myTimeout = setTimeout(removeRingSizeInTitles, 3000);

